import Page from "webPage/Page";
import NewsFilters from "../NewsFilters";

Page.register(['/news-and-events/', '/news-and-events/page/([0-9]+)/', '/news-and-events/type/([^/]+)/', '/news-and-events/type/([^/]+)/page/([0-9]+)/'], () => {

    new NewsFilters($('.js-filter-form'), $('.js-articles-zone'), $('.js-articles-section'));
});
